/**
 * Schedule Data
 * 
 * Edit the descriptions below for each mix.
 * Descriptions support multi-line text (use template literals).
 * Links are separate properties for clickable boxes.
 */

const scheduleData = [
  {
    id: 1,
    time: "12:00-12:43",
    title: "Cultural Imperialism Mix",
    artist: "Emily Zorro",
    genres: "jazz, latin music, hip hop",
    description: `
Questions i thought about while making this mix: 
What historical processes have shaped your 
preferred genres of music? Is your taste in 
music a matter of individual choice? or is it 
more a product of your environment? What impact 
does globalization have on the way you engage 
with music? what impact does commercialism have? 
Is american music internationally popular solely 
on the basis of its aesthetic strength? How can 
we celebrate the beauty that comes with cultural 
exchange while guarding against the threat of 
loss of cultural tradition and heritage?
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/emilyzorro",
      instagram: "https://instagram.com/emilyzorro"
    }
  },
  {
    id: 2,
    time: "12:43-13:43",
    title: "Ponder",
    artist: "Cröak",
    genres: "jazz, art rock, ambient",
    description: `
A mellow drift through spacey jazz and leftfield 
music. This mix moves between cosmic meditations 
and playful detours, weaving together soulful 
rhythms and unexpected turns. A soundtrack for 
late nights, slow mornings, or any time you feel 
like getting a little lost.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/croakbxl",
      instagram: "https://instagram.com/croak.bxl"
    }
  },
  {
    id: 3,
    time: "13:43-14:36",
    title: "Ruta #88",
    artist: "Dianoches",
    genres: "boleros, banda, neoperreo",
    description: `
A series of songs from various Mexican genres 
spanning from Boleros and Mariachi to Tribal 
and NeoPerreo! Hope you all enjoy.
    `.trim(),
    links: {
      instagram: "https://instagram.com/dianoches",
      spotify: "https://open.spotify.com/show/4XncbK38DH5b4LzkTlhnsU"
    }
  },
  {
    id: 4,
    time: "14:36-15:47",
    title: "biking around my head",
    artist: "ant",
    genres: "experimental, spiritual jazz, beats, spoken word",
    description: `
I hop on my bike, put on my headphones, and this 
is what I hear. Field recordings taken on the bike 
are blended with my favorite songs to ride to. As 
recordings of passerby on the street filter in and 
out, so too do short stories, tangents, and memories 
pass from left to right ear as I bike through the 
landmarks of my mind.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/antoniuh",
      instagram: "https://instagram.com/antoniuh"
    }
  },
  {
    id: 5,
    time: "15:47-16:46",
    title: "sunsunsun",
    artist: "Magi Ludi",
    genres: "",
    description: `
semi chaotic, kind of idyllic mix for the homies 
at systm. few bops, some crooners, lots of mistakes, 
all vibes. magi ludi a.k.a Gustave Muhozi is a thing 
doing art things, writing anything, sometimes playing.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/gustavemuhozi",
      instagram: "https://instagram.com/gustavemuho"
    }
  },
  {
    id: 6,
    time: "16:46-17:50",
    title: "lossless",
    artist: "neorah",
    genres: "experimental, slowed and reverbed, ambient, downtempo",
    description: `
This mix is made with slowed ( + reverb ) songs. 
In contrast to analog audio that feels warm, slowed 
down digital audio has a distinctly cold feel that 
stems out of the way the data is spread out by the 
software. What remains are the ghosts of the sound 
and data, trying to hold on but getting pulled apart. 
This mix looks for beauty in digital degradation. 
It might be best suited for your local kethead or 
doomy tiktoker.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/kioskradio/haroen-kiosk-radio-02-04-2025?si=e7151e72dcfb413eb1d6ee8d0c4a20e3&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"
    }
  },
  {
    id: 7,
    time: "17:50-18:34",
    title: "Altered Religion",
    artist: "jun33",
    genres: "downtempo, breakbeat, ambient, baile",
    description: `
Hi I'm jun33 and I DJ on the weekends, sometimes.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/jun33music",
      instagram: "https://instagram.com/j___olga"
    }
  },
  {
    id: 8,
    time: "18:34-19:34",
    title: "Are u drunk?",
    artist: "Loronze Luego",
    genres: "trap, xp, edm",
    description: `
I think I'm gonna get on someone's nerves today.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/loronzeluego",
      instagram: "https://instagram.com/loronzeluego"
    }
  },
  {
    id: 9,
    time: "19:34-20:35",
    title: "MT1",
    artist: "she_skin",
    genres: "r&b, pop",
    description: `
1 hour soundtrack featuring remixed, rare, and 
unreleased tunes reporting from Virginia. 
Lessss'rok! I C T S N U worldwide ent.
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/she_skin",
      instagram: "https://instagram.com/she_skin",
      website: "https://sheskin.org"
    }
  },
  {
    id: 10,
    time: "20:35-21:35",
    title: "Sounds of Late Night London",
    artist: "Ifeoluwa",
    genres: "dubstep, gqom, hyperpop",
    description: `
I recently played a new club night in Bristol called 
"Dollstep" for Trans+ & non-binary people but focusing 
on bass music. It was a really beautiful event, and 
given the recent news here in the U.K., very much needed. 
So here are some of the tracks I remember playing. I hope 
anyone listening can spend an hour just immersed in the 
sounds, forgetting about the world around them xx
    `.trim(),
    links: {
      soundcloud: "https://soundcloud.com/ifeoluwa_1234",
      instagram: "https://instagram.com/ifeoluwa_1234"
    }
  }
];

export default scheduleData;
